var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"value":_vm.active}},[_c('vs-tab',{attrs:{"label":"Price"}},[_c('Table',{attrs:{"draw":_vm.draw}})],1),_c('vs-tab',{attrs:{"label":"Discount"}},[_c('div',{staticClass:"tab-text"},[_c('TableDiscount',{attrs:{"draw":_vm.draw}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }